import React from 'react';
import { COPY } from './copy';

const BADGES = {
  open_info_requested: { label: COPY.status.openInfoRequested, color: COPY.hex.alertRed },
  open_info_added: { label: COPY.status.openInfoAdded, color: COPY.hex.teal },
  closed_info_requested: { label: COPY.status.closedInfoRequested, color: COPY.hex.alertRed },
  closed_info_added: { label: COPY.status.closedInfoAdded, color: COPY.hex.closedBlue },
};

const RaiStatusBadge = ({ overlay }) => {
  const config = BADGES[overlay];
  if (!config) return null;

  return (
    <span
      className="inline-block text-white text-xs font-semibold uppercase px-2 py-1 rounded mt-1"
      style={{ backgroundColor: config.color }}
    >
      {config.label}
    </span>
  );
};

export default RaiStatusBadge;
